import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import axios from 'axios';
import { useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { deleteMxAction } from '../../services/apiNew';
import { addToast, ToastCategories, ToastTypes } from '../../models/toasts';

function usePersistMxActionDelete(
  mxItemId: string,
  actionSingular: string,
): (actionId: string) => Promise<void> {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();

  return useCallback(
    async (actionId: string) => {
      try {
        await deleteMxAction(actionId);
        queryClient.invalidateQueries({ queryKey: ['mxActions', mxItemId] });
      } catch (err) {
        const errorData =
          typeof axios.isAxiosError === 'function' && axios.isAxiosError(err)
            ? err.response?.data
            : (err as { response?: { data?: { error?: unknown } } })?.response?.data;
        const message =
          errorData?.error != null
            ? String(errorData.error)
            : formatMessage({ id: 'text.unableToDeleteAction' }, { actionSingular });
        dispatch(
          addToast({
            payload: {
              title: formatMessage({ id: 'text.actionDeletionError' }, { actionSingular }),
              message,
              type: ToastTypes.ERROR,
              category: ToastCategories.FLAG,
            },
          }),
        );
        throw err;
      }
    },
    [dispatch, formatMessage, mxItemId, queryClient, actionSingular],
  );
}

export default usePersistMxActionDelete;